import { useNavigate } from "react-router-dom";
import "./Confirmation.css";
import Button from "@mui/material/Button";
import { useState } from "react";
import axios from "axios";
import { makeRequest } from "../makeRequest";

function Confirmation({ email, registrationId }) {
  const navigate = useNavigate();

  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState(null); // success | error | warning
  const [message, setMessage] = useState("");

  const handleResend = async () => {
    // 🛑 FAIL FAST (frontend)
    if (!registrationId) {
      setStatus("error");
      setMessage("Impossible de renvoyer le courriel (ID manquant).");
      return;
    }

    if (!email) {
      setStatus("error");
      setMessage("Adresse courriel manquante.");
      return;
    }

    try {
      setSending(true);
      setStatus(null);
      setMessage("");

      const { data } = await makeRequest.post(
        `/registrations/resend-confirmation/${registrationId}`
      );

      if (!data?.success) {
        throw new Error("Email not sent");
      }

      setStatus("success");
      setMessage("Courriel renvoyé avec succès ✅");
    } catch (err) {
      console.error("Resend failed:", err);
      setStatus("error");
      setMessage("Erreur lors de l’envoi. Réessayez plus tard.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="relative border-2 border-white aspect-3/4 max-w-[300px] w-[80%] sm-shadow rounded-lg bg-white h-[450px]">
      {/* ICON */}
      <div className="relative top-[-10%] left-[50%] translate-x-[-50%] h-1/4 translate-y-[50%] xxs-shadow">
        <div className="swal-icon swal-icon--success">
          <span className="swal-icon--success__line swal-icon--success__line--long"></span>
          <span className="swal-icon--success__line swal-icon--success__line--tip"></span>
          <div className="swal-icon--success__ring"></div>
          <div className="swal-icon--success__hide-corners"></div>
        </div>
      </div>

      {/* CONTENT */}
      <div className="w-full h-2/3 absolute bg-white bottom-0 text-center pt-4">
        <h1 className="text-4xl excelFont">Merci!</h1>
        <h2>Inscription terminée</h2>

        <p className="p-4 pb-2">
          Un message est envoyé à :
          <br />
          <b>{email || "—"}</b>
        </p>

        {/* RESEND */}
        <div className="px-6 mt-3">
          <p className="text-sm pb-1"> Pas reçu?</p>
          <div className={`bouncy-transition hover:scale-110`}>
            
            <button
            fullWidth
            variant="outlined"
            size="small"
            disabled={sending}
            onClick={handleResend} className="  bg-black relative text-white title  border-black select-none cursor-pointer fade-in xs-shadow px-2 rounded-xl text-2xl mb-4 z-40"
          >
            {sending ? "Envoi..." : "Renvoyer le courriel"}
          </button>
          </div>

          {/* {status && (
            <p
              className={`text-sm mt-2 ${
                status === "success"
                  ? "text-green-600"
                  : "text-red-600"
              }`}
            >
              {message}
            </p>
          )} */}
        </div>

        {/* BACK */}
        <div className={`bouncy-transition hover:scale-110`}>
            <a
              href={`/Cours`}
              className={`bg-black relative text-white title border-4 border-black select-none cursor-pointer fade-in xs-shadow p-2 rounded-xl text-4xl z-40`}
            >
              Retour aux cours
            </a>
          </div>
      </div>
    </div>
  );
}

export default Confirmation;
